module.exports = __webpack_public_path__ + "img/v6.f76b8de0.png";